import { LOGIN_SUCCESS, LOGOUT_REQUEST } from "../../Actions/actionTypes";

const initialState = {
  isAuthenticated: false,
  username: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        username: action.payload,
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        isAuthenticated: false,
        username: "",
      };
    default:
      return state;
  }
}
